import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

const ThemedButton = ({onClick, reversed = false, ...props}) => (
  <Button className={`button primary-button ${reversed && 'reversed'} ${props.disabled && 'disabled'}`} onClick={onClick} {...props}>
    {props.children}
  </Button>
)

ThemedButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default ThemedButton;
